import { render } from "./AllProductsView.vue?vue&type=template&id=73b7bc46"
import script from "./AllProductsView.vue?vue&type=script&lang=js"
export * from "./AllProductsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__